module.exports = __webpack_public_path__ + "static/media/parceiro-ciet.66f13afe.webp";